/**
 * @generated SignedSource<<333454ce1fc5ec89b6a393404450a9bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduleItemConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"ScheduleItemFragment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"PageInfoFragment">;
  } | null | undefined;
  readonly structure: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"StructureFragment">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "ScheduleItemConnectionFragment";
};
export type ScheduleItemConnectionFragment$key = {
  readonly " $data"?: ScheduleItemConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleItemConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleItemConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScheduleItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ScheduleItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ScheduleItemFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Structure",
      "kind": "LinkedField",
      "name": "structure",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StructureFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ScheduleItemConnection",
  "abstractKey": null
};

(node as any).hash = "0e2b32c18f184bbeff7975f2e7334e09";

export default node;
